import * as MuiIcons from '@mui/icons-material'
import { ComponentType } from 'react'

const formatName = (name: string): string => {
  const nameMap: { [key: string]: string } = {
    eventavailable: 'EventAvailable',
    tableview: 'TableView',
    lock_person: 'LockPerson',
  }

  if (name in nameMap) {
    return nameMap[name]
  }

  return name
    .replace(/outlined$/, 'Outlined')
    .replace(/outline$/, 'Outline')
    .replace(/_/g, ' ')
    .replace(/(?:^|\s)\S/g, (letter) => letter.toUpperCase())
    .replace(/\s+/g, '')
}

const getIconComponent = (name: string) => {
  try {
    return (MuiIcons as Record<string, ComponentType>)[`${formatName(name)}`]
  } catch (error) {
    return MuiIcons.ErrorOutline
  }
}

export default getIconComponent
